/**
 * Green check column for accepted answers. Pure presentational —
 * shown inline next to the vote stack on the accepted answer card.
 */
export function AcceptedCheck({
  accepted,
  size = "md",
}: {
  accepted: boolean;
  size?: "sm" | "md";
}) {
  if (!accepted) return null;
  const cls = size === "sm" ? "w-5 h-5 text-base" : "w-9 h-9 text-2xl";
  return (
    <span
      className={`inline-flex items-center justify-center text-emerald-600 dark:text-emerald-500 ${cls}`}
      title="The asker accepted this as the answer"
      aria-label="Accepted answer"
    >
      ✓
    </span>
  );
}
